const HelpComponent = () => {
  return (
    <>
      <div className="d-flex flex-column-fluid align-items-start container-xxl">
        <div className="flex-row-fluid mt-5" id="kt_content ">
          <div className="card">
            <div className="card-body py-15">
              <div className="mw-lg-950px mx-auto w-100">
                <div className="pb-12">
                  <div className="d-flex flex-column gap-7">
                  <h2 className='mt-5 mb-0'>Overview</h2>
                  <p className="text-gray-700">
                    Whether you're a new merchant looking for a step-by-step guide on setting up your store, or an experienced user seeking answers to specific technical questions, this page provides comprehensive resources to help you navigate every aspect of the platform. From detailed FAQs to in-depth product manuals, you'll find a wealth of information designed to assist you in getting the most out of your merchant experience. Clear, concise instructions are organized by topic, allowing you to quickly find the solutions you need.
                  </p>
                  <p className="text-gray-700">
                  For more personalized assistance, the Help page also offers direct access to customer support channels. You can submit a ticket, chat live with a support representative, or explore community forums where other merchants share their experiences and solutions. Additionally, links to video tutorials, system status updates, and release notes ensure you stay informed about the latest platform features and enhancements. Whether you’re resolving an issue or exploring new ways to optimize your store, the Help page is your essential tool for ongoing success and support.
                  </p>
                  <div className="separator separator-dashed my-3"></div>
                  <h4 className="mb-0">FAQs:</h4>
                  <span className="text-gray-700 text-italic">In active development**</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>          
    </>
  )
}

const HelpWrapper = () => (
    <HelpComponent />
)

export {HelpWrapper}